import { createContext, useContext } from "react";

type SavedProtectionContextType = {
    unsavedChanges: boolean;
    markAsDirty: (obj: unknown) => void;
    markAsClean: (obj: unknown) => void;
    isDirty: (obj: unknown) => boolean;
    discardConfirmation: () => boolean;
};
export const UnsavedChangesContext = createContext<SavedProtectionContextType | undefined>(undefined);

export function useUnsavedChanges() {
    const ctx = useContext(UnsavedChangesContext);
    if (!ctx) throw new Error("useUnsavedChanges must be used within a UnsavedChangesProvider");
    return ctx;
}